/* ENA — Home behaviour. One file, one initialiser per section, all idempotent
   so Shopify's editor re-renders cannot double-bind. */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------------------------------------------------------------------
     QA ronda 5 · media (snippets/ena-media.liquid).

     Background videos render without `autoplay`, so nothing moves before
     this runs and reduced-motion users never see motion. Unmanaged videos
     (`data-ena-bgv=""`) play while in view and pause off screen. Managed
     ones (`data-ena-bgv="managed"`: hero slides, combos, talks) are driven by
     their section's swapper through playBgVideo(). On phones a video whose
     block has a mobile image uses it as poster.
     --------------------------------------------------------------------- */

  function playBgVideo(video, on) {
    if (on && !prefersReducedMotion()) {
      if (video.preload === 'none') video.preload = 'metadata';
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      video.pause();
    }
  }

  var bgObserver = null;

  function initBgVideos(scope) {
    var isPhone = window.matchMedia && window.matchMedia('(max-width: 999px)').matches;

    /* R6 · 17/09-1/2: a block with both a desktop and a mobile clip ships no
       <source> (see snippets/ena-media.liquid), so the browser cannot start
       the wrong file before we choose. Resolved once, like the poster swap
       below: reassigning src on a resize would restart playback mid-scroll. */
    scope.querySelectorAll('video[data-ena-src-mobile]').forEach(function (v) {
      if (v.dataset.enaSrcReady) return;
      v.dataset.enaSrcReady = '1';
      var url = isPhone ? v.dataset.enaSrcMobile : v.dataset.enaSrc;
      if (url) v.src = url;
    });

    scope.querySelectorAll('video[data-poster-mobile]').forEach(function (v) {
      if (isPhone && !v.dataset.enaPosterSwapped) {
        v.dataset.enaPosterSwapped = '1';
        v.dataset.posterDesktop = v.getAttribute('poster') || '';
        v.setAttribute('poster', v.dataset.posterMobile);
      }
    });

    var free = Array.prototype.slice.call(scope.querySelectorAll('video[data-ena-bgv=""]'));
    if (!free.length) return;
    if (!('IntersectionObserver' in window)) {
      free.forEach(function (v) { playBgVideo(v, true); });
      return;
    }
    if (!bgObserver) {
      bgObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { playBgVideo(e.target, e.isIntersecting); });
      }, { threshold: 0.01 });
    }
    free.forEach(function (v) {
      if (v.dataset.enaBgvReady) return;
      v.dataset.enaBgvReady = '1';
      bgObserver.observe(v);
    });
  }

  /* ---------------------------------------------------------------------
     Hero slider (design node `y7qlv`).
     Arrows + "n / total" counter. Autoplay is a section setting; it pauses on
     hover and focus, and respects prefers-reduced-motion.
     --------------------------------------------------------------------- */

  function initHero(root) {
    if (root.dataset.enaHeroReady === '1') return;
    root.dataset.enaHeroReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ena-hhero-slide]'));
    if (slides.length < 2) return;

    var count = root.querySelector('[data-ena-hhero-count]');
    var prev = root.querySelector('[data-ena-hhero-prev]');
    var next = root.querySelector('[data-ena-hhero-next]');
    var index = 0;
    var timer = null;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.dataset.autoplay === 'true' && !reduced;
    var interval = parseInt(root.dataset.interval, 10) || 6000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        var on = n === index;
        slide.classList.toggle('is-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
        /* QA ronda 5 · media: a slide background can be a video; only the
           active slide's plays. */
        var v = slide.querySelector('video[data-ena-bgv]');
        if (v) playBgVideo(v, on);
      });
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* Nothing should animate while the hero is off screen. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.15 }).observe(root);
    } else {
      start();
    }

    show(0);
  }

  /* ---------------------------------------------------------------------
     Objetivos coverflow (design node `QW3eZ`).

     The three card sizes are the design's, set in CSS. This only decides which
     card is centre and translates the track so that card sits on the section's
     midline. Navigation is arrows plus the mouse wheel over the section, which
     is what the brief asks for.

     QA ronda 4 (home) · items 3, 4, 5, 17:
       · the track is an infinite loop on desktop: one full copy of the cards
         is cloned before and after the originals, the arrows are never
         disabled, and once a transition has carried the focus into a copy the
         track jumps back to the equivalent original without animating (item 4)
       · the initial centring is applied without any transition, and again
         whenever the breakpoint changes, so index and geometry never drift
         apart after a resize (items 3 and 5)
       · on phones the track is a native snap scroller, so the arrows drive
         scrollLeft and the focused index is derived from the scroll position
         (item 17). Clones are hidden there; that carousel stays finite.
     --------------------------------------------------------------------- */

  function initCoverflow(root) {
    if (root.dataset.enaCoverReady === '1') return;
    root.dataset.enaCoverReady = '1';

    var viewport = root.querySelector('[data-ena-cover-viewport]');
    var track = root.querySelector('[data-ena-cover-track]');
    var originals = Array.prototype.slice.call(root.querySelectorAll('[data-ena-cover-item]'));
    var prev = root.querySelector('[data-ena-cover-prev]');
    var next = root.querySelector('[data-ena-cover-next]');
    var fill = root.querySelector('[data-ena-cover-progress]');
    var n = originals.length;
    if (!track || n === 0) return;

    var mq = window.matchMedia('(max-width: 999px)');
    var mobile = function () { return mq.matches; };

    /* Clones for the loop. Marked so CSS can hide them on phones and so
       assistive tech only ever meets the originals. */
    function cloneOf(li) {
      var c = li.cloneNode(true);
      c.setAttribute('data-ena-cover-clone', '');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-ena-cover-item');
      c.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = -1; });
      return c;
    }
    if (n > 1 && !track.querySelector('[data-ena-cover-clone]')) {
      originals.forEach(function (li) { track.insertBefore(cloneOf(li), originals[0]); });
      originals.forEach(function (li) { track.appendChild(cloneOf(li)); });
    }
    var all = function () { return Array.prototype.slice.call(track.children); };
    var total = all().length; // 3n on desktop; on phones the clones are display:none

    /* Physical position on the 3n strip. The originals occupy [n, 2n). The
       starting card can be chosen in the section (data-ena-cover-start, 0-based);
       it defaults to the middle one, which is where the design puts the focus. */
    var startIndex = parseInt(root.dataset.enaCoverStart, 10);
    if (isNaN(startIndex) || startIndex < 0 || startIndex >= n) startIndex = Math.floor(n / 2);
    var pos = n + startIndex;
    var normTimer = null;

    function logical(p) { return ((p % n) + n) % n; }

    function px(name, fallback) {
      var v = parseFloat(getComputedStyle(root).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    }

    function paint() {
      all().forEach(function (item, i) {
        item.classList.toggle('is-center', i === pos);
        item.classList.toggle('is-near', Math.abs(i - pos) === 1);
      });
      var idx = logical(pos);
      if (fill) {
        var pct = n > 1 ? idx / (n - 1) : 0;
        fill.style.width = 100 / n + '%';
        fill.style.transform = 'translateX(' + pct * (n - 1) * 100 + '%)';
      }
      /* Item 4 AC2: the loop has no ends, so the arrows never disable here.
         On phones the finite scroller sets them in syncEnds(). */
      if (!mobile()) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
      }
    }

    /* Centre the focused card.

       Measuring offsetLeft here reads the track mid-transition - the cards
       animate their width over 0.45s - which left the focused card up to 56px
       off the midline. Every card is the same width except the focused one, so
       the final geometry is arithmetic, and the numbers come from the CSS
       variables that hold the design's sizes. */
    function offsetFor(p) {
      var w = px('--ena-cover-w', 296);
      var wc = px('--ena-cover-w-center', 360);
      var gap = px('--ena-cover-gap', 8);
      /* The track starts inside the viewport's padding, so that has to come out
         of the sum - leaving it in put every card exactly one padding (24px)
         off the midline. */
      var padLeft = parseFloat(getComputedStyle(viewport).paddingLeft) || 0;
      var left = p * (w + gap);
      return left + wc / 2 - (viewport.clientWidth / 2 - padLeft);
    }

    /* `is-static` switches off the track and card transitions for one frame,
       so a repositioning that must not be seen (first paint, the loop's silent
       jump, a breakpoint change) really is not seen. */
    function place(p, animate) {
      if (!animate) track.classList.add('is-static');
      track.style.transform = 'translateX(' + -offsetFor(p) + 'px)';
      if (!animate) {
        void track.offsetWidth;
        track.classList.remove('is-static');
      }
    }

    function jumpTo(p) {
      pos = p;
      track.classList.add('is-static');
      paint();
      place(pos, false);
      void track.offsetWidth;
      track.classList.remove('is-static');
    }

    /* After a transition has carried the focus into one of the copies, come
       back to the same card in the original set. Nothing moves on screen. */
    function normalise() {
      clearTimeout(normTimer);
      normTimer = setTimeout(function () {
        if (mobile()) return;
        if (pos >= n && pos < 2 * n) return;
        jumpTo(n + logical(pos));
      }, 480);
    }

    function goDesktop(p) {
      /* Rapid presses can run past the strip's ends before normalise() fires;
         fold back first, then take the step. */
      if (p < 1 || p > total - 2) {
        var dir = p > pos ? 1 : -1;
        jumpTo(n + logical(pos));
        p = pos + dir;
      }
      pos = p;
      paint();
      requestAnimationFrame(function () { place(pos, true); });
      normalise();
    }

    /* ---- phones: native scroll ---- */

    function scrollLeftFor(item) {
      var tr = track.getBoundingClientRect();
      var ir = item.getBoundingClientRect();
      return track.scrollLeft + (ir.left - tr.left) + ir.width / 2 - track.clientWidth / 2;
    }

    function syncEnds() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    function goMobile(idx, smooth) {
      idx = Math.max(0, Math.min(n - 1, idx));
      track.scrollTo({ left: scrollLeftFor(originals[idx]), behavior: smooth ? 'smooth' : 'auto' });
      pos = n + idx;
      paint();
      syncEnds();
    }

    var scrollRaf = null;
    function syncFromScroll() {
      if (!mobile() || scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        var tr = track.getBoundingClientRect();
        var mid = tr.left + track.clientWidth / 2;
        var best = 0;
        var bestD = Infinity;
        originals.forEach(function (item, i) {
          var r = item.getBoundingClientRect();
          var d = Math.abs((r.left + r.right) / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        pos = n + best;
        paint();
        syncEnds();
      });
    }

    function go(p) {
      if (mobile()) goMobile(p - n, true);
      else goDesktop(p);
    }

    if (prev) prev.addEventListener('click', function () { go(pos - 1); });
    if (next) next.addEventListener('click', function () { go(pos + 1); });

    /* Wheel over the section advances the carousel. Only when the gesture is
       clearly horizontal-ish or the section is the thing under the pointer, and
       never on touch, so the page can still be scrolled past. */
    /* QA ronda 6 · Luchi: one card per gesture, and no card at all for a
       grazing touch. A trackpad swipe is a burst of wheel events; the
       deltas accumulate and the carousel steps once when they pass 80px,
       then ignores the rest of the burst. The 320ms lock alone let a long
       swipe step three times.

       R6 · 16/09-4: "quiet for 260ms" was the only way out of the lock, but
       macOS momentum keeps emitting decaying deltas for over a second, so a
       second deliberate swipe landed inside the still-running burst and was
       eaten. A fresh finger stroke is detectable inside the burst — its
       delta jumps against the decaying tail, or its sign flips — but only
       AFTER the burst has actually entered its decay: a big stroke's deltas
       keep rising past the step threshold, and an unguarded spike test read
       that rise as new strokes (one long swipe stepped 2-3 cards). So the
       lock only re-arms once a run of non-increasing deltas (momentum) has
       been seen; while the finger is still accelerating, nothing unlocks. */
    var wheelAcc = 0;
    var wheelStepped = false;
    var wheelQuiet = null;
    var wheelPrev = 0;
    var wheelDecay = 0;
    root.addEventListener(
      'wheel',
      function (event) {
        if (mobile()) return;
        var dx = Math.abs(event.deltaX);
        var dy = Math.abs(event.deltaY);
        if (dx < dy) return;
        event.preventDefault();
        clearTimeout(wheelQuiet);
        wheelQuiet = setTimeout(function () {
          wheelAcc = 0; wheelStepped = false; wheelPrev = 0; wheelDecay = 0;
        }, 200);
        var d = event.deltaX;
        if (wheelStepped) {
          var ad = Math.abs(d);
          var ap = Math.abs(wheelPrev);
          var decaying = wheelDecay >= 3;
          var spiking = ad > 10 && ad > ap * 1.5;
          var flipped = ad > 10 && (d > 0) !== (wheelPrev > 0);
          if (ad <= ap + 1) wheelDecay++;
          else if (!decaying) wheelDecay = 0;
          wheelPrev = d;
          if (!decaying || (!spiking && !flipped)) return;
          wheelStepped = false;
          wheelAcc = 0;
          wheelDecay = 0;
        }
        wheelPrev = d;
        wheelAcc += d;
        if (Math.abs(wheelAcc) < 80) return;
        wheelStepped = true;
        wheelDecay = 0;
        go(pos + (wheelAcc > 0 ? 1 : -1));
        wheelAcc = 0;
      },
      { passive: false }
    );

    /* A click on a card other than the focused one brings it to the centre
       (the link still navigates, as before). */
    track.addEventListener('click', function (event) {
      var li = event.target.closest('li');
      if (!li || li.parentNode !== track) return;
      var i = all().indexOf(li);
      if (i !== -1 && i !== pos) go(i);
    });

    track.addEventListener('scroll', syncFromScroll, { passive: true });

    /* Item 5: a resize - and above all crossing the breakpoint - re-syncs
       index and geometry instead of leaving one mechanism's state under the
       other's CSS. */
    function relayout() {
      if (mobile()) {
        track.style.transform = '';
        goMobile(logical(pos), false);
      } else {
        jumpTo(n + logical(pos));
      }
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(relayout, 120);
    });
    if (mq.addEventListener) mq.addEventListener('change', relayout);

    /* Item 3: first position, no transition, on both layouts. */
    relayout();
  }

  /* ---------------------------------------------------------------------
     Card rail — Journey `R0SsH` and Redefiniendo Salud `PlrJp`.
     A native scroll container with arrow buttons; one card per press. The
     arrows disable at the ends so they never look live when they are not.
     --------------------------------------------------------------------- */

  function initRail(root) {
    if (root.dataset.enaRailReady === '1') return;
    root.dataset.enaRailReady = '1';

    var track = root.querySelector('[data-ena-rail-track]');
    var prev = root.querySelector('[data-ena-rail-prev]');
    var next = root.querySelector('[data-ena-rail-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  /* ---------------------------------------------------------------------
     Video Space `mqEL4` — the poster and play button hand over to the video
     on first press. Nothing preloads until then.
     --------------------------------------------------------------------- */

  function initVideo(root) {
    if (root.dataset.enaVideoReady === '1') return;
    root.dataset.enaVideoReady = '1';

    var btn = root.querySelector('[data-ena-video-play]');
    var video = root.querySelector('[data-ena-video-el]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!video) return;
      /* QA ronda 6 · 16/09 · item 1: the section may carry a second file for
         phones. Chosen here, on the first press, so the desktop file is never
         fetched on a phone (the element has preload="none"). Setting `src`
         on the element wins over the <source> child. */
      if (!video.dataset.enaSrcPicked) {
        video.dataset.enaSrcPicked = '1';
        var phone = window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
        var pick = phone && video.dataset.enaSrcMobile ? video.dataset.enaSrcMobile : video.dataset.enaSrc;
        if (pick) video.src = pick;
      }
      root.classList.add('is-playing');
      video.setAttribute('controls', '');
      video.play();
    });
  }

  /* ---------------------------------------------------------------------
     Hotspots `X5Cvj` — QA ronda 4 (home) · item 6: the cards reveal on hover
     and focus-within, which CSS handles entirely. The click-to-toggle layer
     (is-open / aria-expanded) is gone; the dot stays a focusable button so the
     keyboard path still opens its card.
     --------------------------------------------------------------------- */

  /* ---------------------------------------------------------------------
     ENA Talks `Fnlxc` and Combos `g2tXP`.

     Same shape: a set of triggers, a set of background photos and a set of
     panels, all kept in step. Talks switches on click (the brief calls it a
     click), Combos on hover as well - "al pasar el mouse por el nombre de un
     combo cambian de forma sincronizada".
     --------------------------------------------------------------------- */

  function initSwapper(root, opts) {
    if (root.dataset[opts.readyKey] === '1') return;
    root.dataset[opts.readyKey] = '1';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[' + opts.trigger + ']'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[' + opts.panel + ']'));
    var bgs = Array.prototype.slice.call(root.querySelectorAll('[' + opts.bg + ']'));
    if (triggers.length === 0) return;

    function show(i) {
      triggers.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (t.hasAttribute('role')) t.setAttribute('aria-selected', String(on));
        /* R5M · 9 / mobile item 2: on phones the combo names are a horizontal
           strip; the active one is always centred in it (the strip carries
           50% side padding so the first and last can centre too). Done by
           hand on the list's scrollLeft: scrollIntoView could also move the
           page vertically. */
        if (on && opts.scrollTab) centerTab(t, true);
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      bgs.forEach(function (b, n) {
        var on = n === i;
        b.classList.toggle('is-active', on);
        /* R5H · 7: a background can be a <video>; only the active one plays. */
        if (b.tagName === 'VIDEO') playBgVideo(b, on);
      });
    }

    /* QA ronda 5 · media: managed videos carry no autoplay, so start the
       active one (and make sure the rest are parked) at init. */
    bgs.forEach(function (b) {
      if (b.tagName === 'VIDEO') playBgVideo(b, b.classList.contains('is-active'));
    });

    var current = 0;
    var origShow = show;
    show = function (i) { current = i; origShow(i); };

    function centerTab(t, smooth) {
      if (!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches)) return;
      var list = t.closest('ul');
      if (!list) return;
      var lr = list.getBoundingClientRect();
      var tr = t.getBoundingClientRect();
      var left = list.scrollLeft + (tr.left + tr.width / 2) - (lr.left + lr.width / 2);
      if (list.scrollTo) list.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      else list.scrollLeft = left;
    }

    /* Initial position: the active name sits centred on load. */
    if (opts.scrollTab) {
      var initial = triggers.filter(function (t) { return t.classList.contains('is-active'); })[0];
      if (initial) centerTab(initial, false);
    }

    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      if (opts.onHover) {
        t.addEventListener('mouseenter', function () { show(i); });
        t.addEventListener('focus', function () { show(i); });
      }
    });

    return { show: show, count: triggers.length, index: function () { return current; } };
  }

  function initTalks(root) {
    initSwapper(root, { readyKey: 'enaTalksReady', trigger: 'data-ena-talks-ep',
      panel: 'data-ena-talks-panel', bg: 'data-ena-talks-bg', onHover: false });
    initTalksArrows(root);

    /* R5H · 7: the first background video carries `autoplay`, which ignores
       the user's motion preference - stop it here for those users. */
    if (prefersReducedMotion()) {
      root.querySelectorAll('video[data-ena-talks-bg]').forEach(function (v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
    }
  }

  /* QA ronda 4 (home) · item 11: the episode selector scrolls inside a fixed
     window and two arrows, above and below it, step it by one thumbnail. They
     disable at the ends, like the card rails do. On phones the selector is a
     horizontal native scroller and the arrows are hidden by CSS. */
  function initTalksArrows(root) {
    if (root.dataset.enaTalksArrowsReady === '1') return;
    root.dataset.enaTalksArrowsReady = '1';

    var list = root.querySelector('[data-ena-talks-list]');
    var up = root.querySelector('[data-ena-talks-up]');
    var down = root.querySelector('[data-ena-talks-down]');
    if (!list || (!up && !down)) return;

    function step() {
      var ep = list.querySelector('[data-ena-talks-ep]');
      var gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      return (ep ? ep.getBoundingClientRect().height : 82) + gap;
    }

    function sync() {
      var max = list.scrollHeight - list.clientHeight;
      if (up) up.disabled = list.scrollTop <= 2;
      if (down) down.disabled = max <= 2 || list.scrollTop >= max - 2;
    }

    if (up) up.addEventListener('click', function () { list.scrollBy({ top: -step(), behavior: 'smooth' }); });
    if (down) down.addEventListener('click', function () { list.scrollBy({ top: step(), behavior: 'smooth' }); });

    /* Selecting an episode keeps it in view. */
    list.addEventListener('click', function (event) {
      var ep = event.target.closest('[data-ena-talks-ep]');
      if (ep && ep.scrollIntoView) ep.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });

    list.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(list);
    sync();
  }

  function initCombos(root) {
    var api = initSwapper(root, { readyKey: 'enaCombosReady', trigger: 'data-ena-combos-name',
      panel: 'data-ena-combos-card', bg: 'data-ena-combos-bg', onHover: true, scrollTab: true });
    if (!api || api.count < 2) return;

    /* QA ronda 5 (desktop) · item 1: the combos rotate on their own every N
       seconds (section setting) and hold while the pointer is over the
       section, while it has keyboard focus, while it is off screen, and for
       reduced-motion users. Any manual pick restarts the clock. */
    if (root.dataset.autoplay !== 'true' || prefersReducedMotion()) return;
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var timer = null;
    var hovered = false;
    var visible = true;

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (hovered || !visible) return;
      timer = setInterval(function () { api.show((api.index() + 1) % api.count); }, interval);
    }

    root.addEventListener('pointerenter', function () { hovered = true; stop(); });
    root.addEventListener('pointerleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { hovered = true; stop(); });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      hovered = false; start();
    });
    root.querySelectorAll('[data-ena-combos-name]').forEach(function (t) {
      t.addEventListener('click', function () { if (!hovered) start(); });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { visible = e.isIntersecting; visible ? start() : stop(); });
      }, { threshold: 0.2 }).observe(root);
    } else {
      start();
    }
  }

  /* R5M · 10 — Reseñas on phones run as two horizontal marquee lanes; a
     finger resting on them pauses both (hover does the same on desktop via
     CSS). Pointer events cover mouse, pen and touch. */
  function initReviews(root) {
    var cards = root.querySelector('.ena-rev__cards');
    if (!cards || cards.dataset.enaRevReady) return;
    cards.dataset.enaRevReady = '1';
    function pause() { cards.classList.add('is-paused'); }
    function resume() { cards.classList.remove('is-paused'); }
    cards.addEventListener('pointerdown', pause, { passive: true });
    cards.addEventListener('pointerup', resume, { passive: true });
    cards.addEventListener('pointercancel', resume, { passive: true });
    cards.addEventListener('pointerleave', resume, { passive: true });
    cards.addEventListener('touchend', resume, { passive: true });
  }

  /* ---------------------------------------------------------------------
     QA ronda 5 (mobile) · item 1 — Hotspots on phones. Tapping a dot opens
     its panel under the figure (one at a time) and marks the dot. Desktop is
     untouched: there the cards open on hover / focus (R4H · 6), so the click
     handler only acts under the phone breakpoint.
     --------------------------------------------------------------------- */
  function initHotspots(root) {
    if (root.dataset.enaHotReady === '1') return;
    root.dataset.enaHotReady = '1';
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ena-hot-dot]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ena-hot-panel]'));
    var drawer = root.querySelector('[data-ena-hot-drawer]');
    if (!dots.length || !panels.length || !drawer) return;
    var sheet = drawer.querySelector('[data-ena-hot-sheet]');
    var count = drawer.querySelector('[data-ena-hot-count]');
    var phone = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
    var current = -1;
    var opener = null;
    var hideTimer = null;

    function select(i) {
      current = (i + panels.length) % panels.length;
      dots.forEach(function (d, n) {
        var on = n === current;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-expanded', String(on));
      });
      panels.forEach(function (p, n) {
        if (n === current) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (count) count.textContent = (current + 1) + ' / ' + panels.length;
    }

    function open(i, from) {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      opener = from || null;
      select(i);
      drawer.removeAttribute('hidden');
      document.documentElement.classList.add('ena-hot-drawer-open');
      /* next frame so the transform transition runs from the closed state */
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      var closeBtn = drawer.querySelector('.ena-hot__sheet-close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('ena-hot-drawer-open');
      dots.forEach(function (d) { d.classList.remove('is-active'); d.setAttribute('aria-expanded', 'false'); });
      hideTimer = setTimeout(function () { drawer.setAttribute('hidden', ''); }, 320);
      if (opener) opener.focus({ preventScroll: true });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (phone && !phone.matches) return;
        open(i, d);
      });
    });
    drawer.querySelectorAll('[data-ena-hot-close]').forEach(function (b) { b.addEventListener('click', close); });
    var prev = drawer.querySelector('[data-ena-hot-prev]');
    var next = drawer.querySelector('[data-ena-hot-next]');
    if (prev) prev.addEventListener('click', function () { select(current - 1); });
    if (next) next.addEventListener('click', function () { select(current + 1); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Swipe down on the sheet closes it. */
    var startY = null;
    if (sheet) {
      sheet.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (startY === null) return;
        var dy = e.touches[0].clientY - startY;
        if (dy > 0) sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      sheet.addEventListener('touchend', function (e) {
        if (startY === null) return;
        var dy = e.changedTouches[0].clientY - startY;
        sheet.style.transform = '';
        startY = null;
        if (dy > 70) close();
      });
    }

    /* Leaving the phone breakpoint with the drawer open would strand it. */
    if (phone && phone.addEventListener) phone.addEventListener('change', function (m) { if (!m.matches) close(); });
  }

  /* ---------------------------------------------------------------------
     QA ronda 5 (mobile) — rails reveal as a unit. reveal.js watches each
     card on its own, so in a horizontal track the cards parked off screen to
     the right stayed hidden until the user swiped to them. When a track
     enters the viewport every card in it gets its reveal, staggered like
     reveal.js does (90ms steps, capped), whether or not it is visible yet.
     --------------------------------------------------------------------- */
  var railRevealObserver = null;

  function revealTrack(track) {
    var kids = Array.prototype.slice.call(track.children).filter(function (k) { return k.hasAttribute('data-reveal'); });
    kids.forEach(function (k, i) {
      if (k.classList.contains('reveal-in')) return;
      if (!k.getAttribute('data-reveal-delay')) k.style.transitionDelay = Math.min(i * 90, 480) + 'ms';
      k.classList.add('reveal-watched', 'reveal-in');
    });
  }

  function initRailReveal(scope) {
    var tracks = Array.prototype.slice.call(scope.querySelectorAll('.ena-rail__track, .ena-pgrid__grid, .ena-blog__posts, .ena-athletes__track'));
    if (!tracks.length) return;
    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      tracks.forEach(revealTrack);
      return;
    }
    if (!railRevealObserver) {
      railRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          revealTrack(e.target);
          railRevealObserver.unobserve(e.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    tracks.forEach(function (t) {
      if (t.dataset.enaRailRevealReady) return;
      t.dataset.enaRailRevealReady = '1';
      railRevealObserver.observe(t);
    });
  }

  /* ------------------------------------------------------------------- */

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ena-hhero]').forEach(initHero);
    root.querySelectorAll('[data-ena-cover]').forEach(initCoverflow);
    root.querySelectorAll('[data-ena-rail]').forEach(initRail);
    root.querySelectorAll('[data-ena-video]').forEach(initVideo);
    root.querySelectorAll('[data-ena-talks]').forEach(initTalks);
    root.querySelectorAll('[data-ena-combos]').forEach(initCombos);
    root.querySelectorAll('[data-ena-reviews]').forEach(initReviews);
    root.querySelectorAll('[data-ena-hot]').forEach(initHotspots);
    initRailReveal(root);
    initBgVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* ==========================================================================
   22/09 item 8 — newsletter "pestañeo". Shopify's customer form posts to
   /contact and redirects back to the page with ?customer_posted=true and a
   hash, so the whole home reloads and jumps to the form. Submitting in the
   background gives the same result without the reload. If Shopify answers
   with its bot challenge, or the request fails, the form falls back to the
   ordinary submit so nothing is lost.
   ========================================================================== */
(function () {
  function init(root) {
    (root || document).querySelectorAll('form.ena-nl__form').forEach(function (form) {
      if (form.dataset.enaNlReady === '1') return;
      form.dataset.enaNlReady = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('.ena-nl__submit');
        form.classList.add('is-sending');
        if (btn) btn.disabled = true;
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' }
        }).then(function (r) {
          if (!r.ok || /challenge/.test(r.url)) throw new Error('fallback');
          var ok = form.querySelector('.ena-nl__ok');
          if (!ok) {
            ok = document.createElement('p');
            ok.className = 'ena-nl__ok';
            ok.textContent = '¡Listo! Ya estás suscripto.';
            form.appendChild(ok);
          }
          ok.hidden = false;
          var input = form.querySelector('.ena-nl__input');
          if (input) input.value = '';
          form.classList.remove('is-sending');
          form.classList.add('is-done');
          if (btn) btn.disabled = false;
        }).catch(function () {
          form.classList.remove('is-sending');
          if (btn) btn.disabled = false;
          form.dataset.enaNlReady = '0';
          form.submit();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
